// extracted by mini-css-extract-plugin
module.exports = {"container":"IngredientsPanel_container__jDa1c","itemsContainer":"IngredientsPanel_itemsContainer__PWLd_","footer":"IngredientsPanel_footer__UdfCO"};